import { superAdminApi } from "./authService";
import { ApiResponse } from "../types/api";

const RESOURCE = "/super-admin/dashboard/metrics";

export type ServerHealthStatus = "ok" | "degraded" | "critical";

export interface ServerHealthSnapshot {
  status: ServerHealthStatus;
  checked_at: string;
  api: {
    db: "ok" | "failed";
    redis: "ok" | "failed";
  };
  memory: {
    used_bytes: number | null;
    total_bytes: number | null;
    used_percent_bps: number | null;
    source: "host" | "unavailable";
  };
  disk: {
    path: string;
    used_bytes: number | null;
    total_bytes: number | null;
    used_percent_bps: number | null;
    source: "runtime" | "unavailable";
  };
  cpu: {
    load_1: number | null;
    load_5: number | null;
    load_15: number | null;
    source: "runtime" | "unavailable";
  };
  queues: {
    failed_jobs_count: number;
    pending_estimate: number | null;
  };
  php: {
    version: string;
    memory_usage_bytes: number;
    memory_limit_bytes: number | null;
  };
}

export interface RecentTenant {
  id: number;
  name: string;
  created_at: string | null;
  blocked: boolean;
  subscription_status: string | null;
}

/** KPI payload from GET /super-admin/dashboard/metrics (doc 06 § 3.15). */
export interface DashboardMetrics {
  mrr_by_currency: Record<string, number>;
  active_tenants_count: number;
  churn_rate_bps: number;
  canceled_last_30d_count: number;
  total_units_count: number;
  total_professionals_count: number;
  aha_rate_72h_bps: number;
  support_awaiting_tenant_count?: number;
  support_satisfaction_no_open_count?: number;
  trial_tenants_count?: number;
  past_due_tenants_count?: number;
  blocked_tenants_count?: number;
  new_tenants_last_7d_count?: number;
  orphan_accounts_count?: number;
  blog_pending_review_count?: number;
  recent_tenants?: RecentTenant[];
  server_health?: ServerHealthSnapshot;
}

export const getDashboardMetrics = async (): Promise<
  ApiResponse<DashboardMetrics>
> => {
  const response = await superAdminApi.get<ApiResponse<DashboardMetrics>>(
    RESOURCE
  );

  return response.data;
};
